import React, { Component } from "react";
import { Router, Route } from "react-router";

//
import createHistory from "history/createBrowserHistory";
//createHistory = require("history").createBrowserHistory;
//import {createBrowserHistory} from 'history';
//import {useRouterHistory, Router, Route} from 'react-router';



// Page Containers
import HomePage from "../../containers/HomePage";
import PlanetsPage from "../../containers/PlanetsPage";
import SwipePage from "../../containers/AssetPage/index.swipe";
import ProfilePage from "../../containers/ProfilePage";
import ProfileWalletPage from "../../containers/ProfileWalletPage";
import PaymentPage from "../../containers/PaymentPage";
import CreditCardPage from "../../containers/CreditCardPage";
import ProfileAgentPage from "../../containers/ProfileAgent"

import Navbar from "./navbar";



import "./main.css";


class Main extends Component {
  constructor(props) {
    super(props);
    this.history = createHistory();
  }

  render() {
    return (
      <Router history={this.history}>
        <div className="content">

          <Navbar toggleProfileModal={this.toggleProfileModal} />

          <main>
            <Route component={HomePage} exact path="/"  />

            <Route component={PlanetsPage} exact path="/company"  history={this.history}/>

            <Route component={SwipePage} path="/assets/"  />

            <Route component={ProfilePage}        exact path="/profile"  />
            <Route component={ProfileWalletPage}  exact path="/profile/wallet"  />
	          <Route component={CreditCardPage}     exact path="/profile/creditcards"  />
            <Route component={PaymentPage}        exact path="/profile/payment" />
	          <Route component={ProfileAgentPage}   exact path="/profile/agent"/>
	          
          </main>

        </div>
      </Router>
    );
  }
}

export default Main;



// WEBPACK FOOTER //
// ./src/components/Main/index.js